/** @format */

import template from './gb-table-item-tall-card.html';
import './gb-table-item-tall-card.scss';

export const GbTableItemTallCardComponent = {
    template,
    require: {
        gbWidget: '^^',
        gbItemTableWidget: '^^',
        gbTableItem: '^^',
    },
    bindings: {
        item: '<',
        winningBid: '<',
    },
    controller: class GbTableItemTallCardComponent {
        constructor($ccColors, $interval, $timeout) {
            'ngInject';

            this.$ccColors = $ccColors;
            this.$interval = $interval;
            this.$timeout = $timeout;

            this.primaryStyles = {};
            this.accentStyles = {};
            this.selectedWinningBid = null;
            // 3 seconds
            this.intervalTime = 3000;
        }

        $onInit() {
            const biddingItem = this.getBiddingItem();
            if (biddingItem && Array.isArray(biddingItem.winning_bids)) {
                if (biddingItem.winning_bids.length === 1) {
                    this.selectedWinningBid = biddingItem.winning_bids[0];
                }

                // multiple winning bids
                if (biddingItem.winning_bids.length > 1) {
                    this.selectedWinningBid = biddingItem.winning_bids[0];
                    this.$timeout(() => {
                        this.selectedWinningBidInterval();
                    }, this.intervalTime);
                }
            }
        }

        selectedWinningBidInterval() {
            this.$interval(() => {
                const length = this.getBiddingItem().winning_bids.length;
                const currentIndex = this.getBiddingItem().winning_bids.indexOf(this.selectedWinningBid);

                if (currentIndex === length - 1) {
                    this.selectedWinningBid = this.getBiddingItem().winning_bids[0];
                } else {
                    this.selectedWinningBid = this.getBiddingItem().winning_bids[currentIndex + 1];
                }
            }, this.intervalTime);
        }

        getPrimaryStyles() {
            let bgColor = this.gbWidget.widget.table_primary_color;

            if (bgColor) {
                this.primaryStyles['background-color'] = bgColor;
                this.primaryStyles['color'] = this.$ccColors.getContrast(bgColor);
            }

            return this.primaryStyles;
        }

        getAccentStyles() {
            let bgColor = this.gbWidget.widget.table_accent_color;

            if (bgColor) {
                this.accentStyles['background-color'] = bgColor;
                this.accentStyles['color'] = this.$ccColors.getContrast(bgColor);
            }

            return this.accentStyles;
        }

        getBiddingItem() {
            if (this.item.item_type !== 'bidding') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        getDonationItem() {
            if (this.item.item_type !== 'donation') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        hasBids() {
            return !!this.getBiddingItem() && this.getBiddingItem().winning_bids.length > 0;
        }

        getItemImageCss() {
            if (this.isImageContained()) return { 'background-size': 'contain' };

            return '';
        }

        isImageContained() {
            return this.gbWidget && this.gbWidget.widget && this.gbWidget.widget.image_contained;
        }
    },
};
